import { z } from 'zod'

const envSchema = z.object({
  VITE_APP_API_URL: z.string(),
  VITE_APP_API_URL_INVOICING: z.string(),
  VITE_APP_API_URL_PRINTOUT: z.string(),
  VITE_APP_MS_HIR_API_URL: z.string(),
  VITE_APP_AUDIT_TRACKER_URL: z.string(),
  VITE_APP_STORAGE_HOST: z.string(),
  VITE_APP_ENV_NAME: z.string(),
  VITE_APP_TITLE: z.string(),
  VITE_APP_SENTRY_DSN: z.optional(z.string()),
  SENTRY_AUTH_TOKEN: z.optional(z.string()),
  VITE_APP_SUPERSET_DASHBOARD_ACTUAL_ID: z.string(),
  VITE_APP_SUPERSET_DASHBOARD_OLD_ID: z.string(),
  VITE_APP_AUTHORIZER_URL: z.string(),
  VITE_APP_AUTHORIZER_API_TOKEN: z.string(),
  VITE_APP_API_URL_MEDICAL_RECORD_TEMPLATES: z.string(),
  VITE_DETECTIVE_URL: z.string(),
  VITE_APP_CARELINE_CATEGORY_ID: z.string(),
  VITE_APP_CAPTURE_CATEGORY_ID: z.string(),
})

export const env = envSchema.parse(import.meta.env)
